import { useState } from 'react';
import { toast } from 'react-toastify';
import { useAuth } from '../../AuthContext';
import useApi from '../../Api';

const usePlanSubscribe = () => {
  const { token } = useAuth();
  const apiClient = useApi();
  const [isLoading, setIsLoading] = useState(false);

  const subscribe = async (
    plan,
    successRedirect = '/explore/ai-agent',
    failRedirect = '/'
  ) => {
    if (isLoading) return;
    setIsLoading(true);
    try {
      const { data } = await apiClient.post(
        '/stripe/create-checkout-session',
        { plan, success_redirect: successRedirect, fail_redirect: failRedirect },
        { headers: { Authorization: `Bearer ${token}` } }
      );
      if (data.checkout_url) window.location.href = data.checkout_url;
    } catch {
      toast.error('Unable to create checkout session.', {
        position: 'top-center',
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true
      });
    } finally {
      setIsLoading(false);
    }
  };

  return { subscribe, isLoading };
};

export default usePlanSubscribe;
